import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {ActiveRentalsPage} from '../../rentals/active-rentals-page'

export const Route = createFileRoute('/_app/active-rentals')({
    component: ActiveRentalsRoute,
})

function ActiveRentalsRoute() {
    return (
        <Container size="xl" py="xl">
            <ActiveRentalsPage />
        </Container>
    )
}
